import * as React from 'react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';

interface IFormValidationContext {
  activeControl?: string;
  setActiveControl: (controlName: string) => void
  validate: (successCallback?: () => void, failCallback?: () => void) => void;
}

interface IFormValidationProvider {
  children: React.ReactNode;
}

export const FormValidationContext = React.createContext<IFormValidationContext>(undefined!);

export function FormValidationProvider<TFieldValues extends FieldValues>({ children }: IFormValidationProvider) {
  const [activeControl, setActiveControl] = React.useState<string>('');
  const { trigger, clearErrors } = useFormContext<TFieldValues>();
  const formValidation = React.useMemo<IFormValidationContext>(() => ({
    activeControl,
    setActiveControl,
    validate: (successCallback?, failCallback?) => trigger(activeControl as Path<TFieldValues>).then((isValid) => {
      if (isValid) {
        if (successCallback) {
          successCallback();
        }
        clearErrors();
      } else if (failCallback) {
        failCallback();
      }
    }),
  }), [activeControl]);
  return (
    <FormValidationContext.Provider value={formValidation}>
      {children}
    </FormValidationContext.Provider>
  );
}

export const useFormValidation = () => React.useContext(FormValidationContext);
